define('templates/device-templates',['templates/template-builder'], function(TemplateBuilder) {
    return function(options) {
        var templateBuilder = new TemplateBuilder();
        
    	return {
	        /**
	         * HEADERS -------------------------------------------------------
	         */
	        'headers' : {
	            'activationDate' : templateBuilder.basicHeader('activationDate', 'Activation date'),
	            'comStateString' : {
	                'nodeType': 'th',
	                'attributes': {'draggable': 'true'},
	                'id': 'CommunicationStatus',
	                'data': {'key': 'comStateString'},
	                'title': ' ',
	                'content': 'Communication status'
	            },
	            'type' : templateBuilder.basicHeader('type', 'Device type'),
	            'lastPurge' : templateBuilder.basicHeader('lastPurge', 'Last purge'),
	            'pac' : templateBuilder.basicHeader('pac', 'PAC'),
	            'productCertificate' : templateBuilder.basicHeader('productCertificate', 'Product certificate'),
	            'modemCertificate' : templateBuilder.basicHeader('modemCertificate', 'Modem certificate'),
	            'protocol' : templateBuilder.basicHeader('protocol', 'Protocol version'),
	            'tokenState' : templateBuilder.basicHeader('tokenState', 'Token state'),
	            'automaticRenewal' : templateBuilder.basicHeader('automaticRenewal', 'Automatic token renewal'),
	            'deviceGroup' : templateBuilder.basicHeader('deviceGroup', 'Group'),
	            
	            // Sortable headers - see device-templates.js
	            'id' : options.noSort ? templateBuilder.basicHeader('id', 'Id') : templateBuilder.sortableHeader('id', 'Id', 'id'),
	            'lastDate' : options.noSort ? templateBuilder.basicHeader('lastDate', 'Last seen') : templateBuilder.sortableHeader('lastDate', 'Last seen', 'last'),
	            'name' : options.noSort ? templateBuilder.basicHeader('name', 'Name') : templateBuilder.sortableHeader('name', 'Name', 'nameCI')
	            
	        },
	        
	        /**
	         * DATA TEMPLATES -------------------------------------------------------
	         */
	        'templates' : {
	            'activationDate' : templateBuilder.basicNode('${activationDate}'),
	            'comStateString' : {
	                'nodeType':'td',
	                'attributes':{'align':'center'},
	                'content':
	                    {
	                        'nodeType':'div',
	                        'attributes':{'title':'${comStateTitle}'},
	                        'classes':['com-state','com-state-${comStateString}']
	                    }
	            },
	            'type' : templateBuilder.linkNode('${deviceTypeUrl}', '${deviceTypeName}'),
	            'id' : templateBuilder.linkNode('${url}', '${hexId}'),
	            'lastPurge' : templateBuilder.basicNode('${lastPurge}'),
	            'lastDate' : templateBuilder.basicNode('${lastDate}'),
	            'name' : templateBuilder.basicNode('${name}'),
	            'pac' : templateBuilder.basicNode('${pac}'),
	            'productCertificate' : templateBuilder.basicNode('${productCertificate}'),
	            'modemCertificate' : templateBuilder.basicNode('${modemCertificate}'),
	            'protocol' : templateBuilder.basicNode('${protocol}'),
	            'automaticRenewal' : templateBuilder.booleanNode('${automaticRenewal}'),
	            'deviceGroup' : templateBuilder.linkNode('${groupUrl}','${groupName}'),
	            'tokenState' : {
	                'nodeType':'td',
	                'content':
	                    {
	                        'nodeType':'switch_case',
	                        'attributes':{'align':'center'},
	                        'switchCaseField':'${tokenState}',
	                        'switchCase':
	                            {
	                                '0':{
	                                    'nodeType':'span',
	                                    'classes':['icon-check','icon-large','help-tip-icon'],
	                                    'title':'Ok'
	                                },
	                                '1':{
	                                    'nodeType':'span',
	                                    'classes':['icon-ban-circle','icon-large','help-tip-icon'],
	                                    'title':'Off contract'
	                                },
	                                '2':{
	                                    'nodeType':'span',
	                                    'classes':['icon-question-sign','icon-large','help-tip-icon'],
	                                    'title':'Token not consumed'
	                                },
	                                '3':{
	                                    'nodeType':'span',
	                                    'classes':['icon-ban-circle','icon-large','help-tip-icon'],
	                                    'title':'Invalid token'
	                                }
	                            }
	                    }
	            }
	        } // end templates data
    	};
    }; // end return
});

